export const REGIONS: { [key: string]: { name: string; adjective: string } } = {
  AF: { name: 'Africa', adjective: 'African' },
  AN: { name: 'Antarctica', adjective: 'Antarctic' },
  AS: { name: 'Asia', adjective: 'Asian' },
  EU: { name: 'Europe', adjective: 'European' },
  NA: { name: 'North America', adjective: 'North American' },
  OC: { name: 'Oceania', adjective: 'Oceanian' },
  SA: { name: 'South America', adjective: 'South American' },
  XX: { name: 'Global', adjective: 'Global' },
};
